import { createFormContext } from "@mantine/form";
import { geozod } from "shared/utils/zod";
import { z } from "zod";

const SelectedSenderFilterSchema = z.object({
    id: z.string(),
    name: z.string(),
    projectedUsersWithin: z.number(),
    geometry: geozod.polygon(),
});

export const GeoLocationFormSchema = z.object({
    tab: z.enum(["Draw", "Predefined"]),
    selectedLayerId: z.string().nullable(),
    selectedSenderFilters: SelectedSenderFilterSchema.array(),
});

type GeoLocationFormState = z.infer<typeof GeoLocationFormSchema>;
export type GeoTab = GeoLocationFormState["tab"];

export function createGeoLocationFormState(): GeoLocationFormState {
    return {
        tab: "Draw",
        selectedLayerId: null,
        selectedSenderFilters: [],
    };
}

export const [GeoLocationFormProvider, useGeoLocationFormContext, useGeoLocationForm] = createFormContext<GeoLocationFormState>();
